import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, MenuItem, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useApiCaller from 'hooks/apiCaller';

// List of declarations
const declarations = [
  // "Prevention of insider trading",
  //   "Code of Conduct",
  //   "IT Security Policy",
];

const UploadDeclarationForm = ({ onTrigger, row, user }) => {
  // Submit handler
  const apiCaller = useApiCaller();

  console.log('Row', user);
  if (row.courseName) {
    declarations.push(row.courseName);
  }
  const handleSubmit = async (values) => {
    console.log('Form Submitted:', values);
    const formData = new FormData();
    formData.append('courseId', row.courseId);
    formData.append('courseName', row.courseName);

    // When admin uploads on behalf of an employee, row.empId holds the target employee.
    // Always send empId so the backend saves it under the correct employee.
    const targetEmpId = row.empId ?? user.employeeId;
    formData.append('empId', targetEmpId);

    if (values.file instanceof File) {
      const fileExtension = values.file.name.split('.').pop();
      // Use the target employee's ID in the filename, not the logged-in user's
      const newFileName = `Declaration_${targetEmpId}_${row.courseId}_${Date.now()}.${fileExtension}`;
      const renamedFile = new File([values.file], newFileName, {
        type: values.file.type,
        lastModified: values.file.lastModified,
      });
      formData.append('templateFile', renamedFile);
    }

    try {
      const response = await apiCaller.post('/user/make-declaration', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response) {
        toast.success('Declaration Created Successfully!', { theme: 'colored' });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Failed to create declaration.');
    }
    if (onTrigger) {
      onTrigger(values);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          declarationType: row.courseName,
          file: null,
        }}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form>
            {/* Declaration Type Dropdown */}
            <Field
              as={TextField}
              name="declarationType"
              label="Selected Declaration Type"
              fullWidth
              select
              margin="normal"
              disabled
            >
              {declarations.map((declaration, index) => (
                <MenuItem key={index} value={declaration}>
                  {declaration}
                </MenuItem>
              ))}
            </Field>

            {/* File Upload Field */}
            <input
              type="file"
              name="file"
              accept=".doc,.docx,.pdf,image/*"
              onChange={(event) => setFieldValue('file', event.currentTarget.files[0])}
              style={{ margin: '16px 0' }}
            />

            {/* Submit Button */}
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UploadDeclarationForm;
